import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { VocsService } from '../../../services/vocs.service';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { VocTerms } from '../../../models/voc-term';
import { SifaSelection } from '../../../models/sifa-selection';
import { MssListFilters } from '../../../models/mss-list-filters';
// import { globals } from '../../../../globals';
import { ISubscription } from 'rxjs/Subscription';
import { AppContentsService } from '../../../services/app-contents.service';

@Component({
  selector: 'app-search-images-filters',
  templateUrl: './search-images-filters.component.html',
  styleUrls: ['./search-images-filters.component.css']
})
export class SearchImagesFiltersComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    sifaSections: VocTerms;
    sifaParts: VocTerms;
    sifaTreatises: VocTerms;
    sifaChapters: VocTerms;
    sifaOtherElements: VocTerms;
    sifaSelection: SifaSelection;
    searchError: string;
    helpContent: SafeHtml;
    helpContentName: string;

    constructor(
        private sanitizer: DomSanitizer,
        private manuscriptsService: ManuscriptsService,
        private vocsService: VocsService,
        private appContentsService: AppContentsService) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.appContentsService.getPageContents('search-images').subscribe(
                page => {
                    if (page && page.name === 'search-images') {
                        const helpContent = page.contents.find(c => c.name === 'help-images-filters');
                        if (helpContent) {
                            this.helpContentName = helpContent.name;
                            this.helpContent = this.sanitizer.bypassSecurityTrustHtml(helpContent.text);
                        }
                    }
                },
                err => console.error(err)
            )
        );

        /* Load filtering values */
        this.subscriptions.push(
            this.vocsService.getSifaSections().subscribe(response => this.sifaSections = response, err => console.error(err)),
            this.vocsService.getSifaParts().subscribe(response => this.sifaParts = response, err => console.error(err)),
            this.vocsService.getSifaTreatises().subscribe(response => this.sifaTreatises = response, err => console.error(err)),
            this.vocsService.getSifaChapters().subscribe(response => this.sifaChapters = response, err => console.error(err)),
            this.vocsService.getSifaOtherElements().subscribe(response => this.sifaOtherElements = response, err => console.error(err))
        );

        this.sifaSelection = new SifaSelection();
    }

    searchImages(sifaSelection: SifaSelection): void {
        this.searchError = '';
        let validSelection = true;

        if (sifaSelection.isNull()) {
            validSelection = false;
        } else if (sifaSelection.section) {
            if (sifaSelection.section.pkid > 0 && sifaSelection.section.pkid !== 1) {
                if (!sifaSelection.part || !sifaSelection.treatise || !sifaSelection.chapter) {
                    validSelection = false;
                }
            }
        } else if (!sifaSelection.otherElement) {
            validSelection = false;
        }

        if (validSelection) {
            const mssListFilters = new MssListFilters();
            mssListFilters.searchImages = sifaSelection;
            this.manuscriptsService.updateFilters(mssListFilters);
        } else {
            this.searchError = 'Please complete a valid search path!';
            this.manuscriptsService.resetFilters();
        }
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/search-images-filters/search-images-filters.component.ts